import { useCallback, useEffect } from 'react'

export type Position = {
    scrollX: number
    scrollY: number
}
type Callback = (position: Position) => void
type UseScrollPosition = (callback: Callback) => void

export const useScrollPosition: UseScrollPosition = (callback) => {
    const handler = useCallback(() => {
        const position = {
            scrollX: window.scrollX,
            scrollY: window.scrollY,
        }

        callback(position)
    }, [callback])

    useEffect(() => {
        window.addEventListener('scroll', handler)

        return () => {
            window.removeEventListener('scroll', handler)
        }
    }, [handler])

    return { handler }
}
